import React from "react";

function ListIcon() {
  return (
    <span>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.20078 2.3999C6.56426 2.3999 5.95381 2.65276 5.50372 3.10285C5.05364 3.55293 4.80078 4.16338 4.80078 4.7999V19.1999C4.80078 19.8364 5.05364 20.4469 5.50372 20.897C5.95381 21.347 6.56426 21.5999 7.20078 21.5999H16.8008C17.4373 21.5999 18.0478 21.347 18.4978 20.897C18.9479 20.4469 19.2008 19.8364 19.2008 19.1999V8.8967C19.2006 8.26024 18.9477 7.64989 18.4976 7.1999L14.4008 3.1031C13.9508 2.65298 13.3404 2.40004 12.704 2.3999H7.20078ZM9.60078 14.3999C9.60078 14.0816 9.47435 13.7764 9.24931 13.5514C9.02427 13.3263 8.71904 13.1999 8.40078 13.1999C8.08252 13.1999 7.7773 13.3263 7.55225 13.5514C7.32721 13.7764 7.20078 14.0816 7.20078 14.3999V17.9999C7.20078 18.3182 7.32721 18.6234 7.55225 18.8484C7.7773 19.0735 8.08252 19.1999 8.40078 19.1999C8.71904 19.1999 9.02427 19.0735 9.24931 18.8484C9.47435 18.6234 9.60078 18.3182 9.60078 17.9999V14.3999ZM12.0008 10.7999C12.319 10.7999 12.6243 10.9263 12.8493 11.1514C13.0744 11.3764 13.2008 11.6816 13.2008 11.9999V17.9999C13.2008 18.3182 13.0744 18.6234 12.8493 18.8484C12.6243 19.0735 12.319 19.1999 12.0008 19.1999C11.6825 19.1999 11.3773 19.0735 11.1523 18.8484C10.9272 18.6234 10.8008 18.3182 10.8008 17.9999V11.9999C10.8008 11.6816 10.9272 11.3764 11.1523 11.1514C11.3773 10.9263 11.6825 10.7999 12.0008 10.7999ZM16.8008 9.5999C16.8008 9.28164 16.6744 8.97642 16.4493 8.75137C16.2243 8.52633 15.919 8.3999 15.6008 8.3999C15.2825 8.3999 14.9773 8.52633 14.7523 8.75137C14.5272 8.97642 14.4008 9.28164 14.4008 9.5999V17.9999C14.4008 18.3182 14.5272 18.6234 14.7523 18.8484C14.9773 19.0735 15.2825 19.1999 15.6008 19.1999C15.919 19.1999 16.2243 19.0735 16.4493 18.8484C16.6744 18.6234 16.8008 18.3182 16.8008 17.9999V9.5999Z"
          fill="#111827"
        />
      </svg>
    </span>
  );
}

export default ListIcon;
